<template>
    <div class="c-seeds-by-alveolus">
        <div style="font-weight: bold">
            Cantidad de semillas por alvéolo
            <img v-b-modal.modal-csemillas src="/img/iconos/icon_info.svg" alt="icon_info.svg" class="icon_info">
            <modal-block v-cloak title="Cantidad de semillas por alvéolo" :href="route('help.details','semillas-por-alveolo')" desing="ecologico" refer="csemillas">
                Cantidad de semillas sembradas por alvéolo
            </modal-block>

            <b-form-checkbox v-if="options.length > 1" v-model="bpRecommended" class="c-recommend">
                Las que babyplant me aconseje
            </b-form-checkbox>
        </div>
        <div class="c-seeds-by-alveolus-select">
            <div style="position:relative;">
                <b-form-select v-model="seedsByAlveolus" :options="options"></b-form-select>
                <div v-if="bpRecommended" class="recommended-border"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SeedsByAlveolus",
        props: {
            value: {
                type: Number
            },
            recommended: {
                type: Number,
                default: 1
            },
            maxSeedsByAlveolus: {
                type: Number,
                default: 30
            }
        },
        data() {
            return {
                seedsByAlveolus: 1,
                bpRecommended: false,
            }
        },
        computed: {
            options() {
                let options = [];
                for (var i = 1; i <= this.maxSeedsByAlveolus; i++) {
                    options.push(i);
                }
                return options;
            }
        },
        watch: {
            value() {
                this.updatedValue();
            },
            bpRecommended(value) {
                if (value) {
                    this.seedsByAlveolus = this.recommended;
                }
            },
            seedsByAlveolus(value) {
                if (value !== this.recommended) {
                    this.bpRecommended = false;
                }
                this.$emit('input', value);
            },
        },
        methods: {
            updatedValue() {
                this.seedsByAlveolus = this.value;
            }
        },
        created() {
            this.updatedValue();
        }
    }
</script>

<style scoped>
    .c-seeds-by-alveolus {
        background-color: #d6da2f;
        color: #0671b8;
        padding: 15px 500px;
        text-align: left;
        margin-left: -500px;
        margin-right: -500px;
        display: flex;
        flex-wrap: wrap;
        margin-top: 0.5rem;
    }

     .c-seeds-by-alveolus-select {
         max-width: 5em;
         min-width: 5em;
         margin-left: auto;
     }

     .c-seeds-by-alveolus-select .recommended-border {
         width: calc(100% + 8px);
         height: calc(100% + 8px);
         position: absolute;
         left: -4px;
         top: -4px;
         border: solid 1px;
         border-radius: 0.25rem;
     }

    @media (min-width: 992px) {
        .c-seeds-by-alveolus {
            padding: 0.5rem 1.75rem;
            border-radius: 0.25rem;
            border: 1px solid #cbc8c9;
            margin-top: 1.75rem;
            margin-left: 0;
            margin-right: 0;
        }
    }

</style>

<style>
    .c-seeds-by-alveolus .c-recommend .custom-control-input:checked ~ .custom-control-label::before {
        border-color: #048b84;
        background-color: #048b84;
    }

    #app {
        overflow-y: hidden;
    }

</style>
